<template>
    <div class="all">
        <div class="title">Target Areas List</div>
        <div class="btns">
            <el-button
                size="small"
                style="background-color:rgb(129,175,201);color:white"
                @click="$router.push(`/library-editor?id=add`)"
                >Add Target Areas</el-button
            >
            <!-- <el-button size="small" type="danger" @click="deleteData">Delete</el-button> -->
        </div>
        <el-table
            max-height="650"
            :data="tableData"
            stripe
            ref="libraryTable"
            header-row-class-name="tableHeadr"
            v-loading="tableLoad"
            row-key="id"
            @selection-change="handleSelectionChange"
        >
            <!-- <el-table-column type="selection" width="55"></el-table-column>     -->
            <el-table-column label="Library name" width="200">
                <template slot="header">
                    <div
                        class="table-name"
                        style="display: flex; align-items: center"
                    >
                        <div>Target Areas name</div>
                        <!-- <i
                            class="el-icon-circle-plus"
                            style="color: white; margin-left: 20px"
                            @click="
                                $router.push(
                                    `/workout-editor?id=add`
                                )
                            "
                        ></i> -->
                    </div>
                </template>
                <template slot-scope="scope">
                    <div
                        class="tableCell"
                        :title="scope.row.title"
                        @click="
                            $router.push(
                                `/library-editor?id=${scope.row.id}`
                            )
                        "
                    >
                        {{ scope.row.title }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="phone image" min-width="150">
                <template slot-scope="scope">
                    <div style="height: 50px">
                        <img
                            style="height: 100%; width: 100px"
                            :src="
                                $store.state.default_file_url +
                                scope.row.coverImageUrl
                            "
                            alt=""
                        />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="tablet image" min-width="150">
                <template slot-scope="scope">
                    <div style="height: 50px">
                        <img
                            style="height: 100%; width:100px"
                            :src="
                                $store.state.default_file_url +
                                scope.row.coverImageTabletUrl
                            "
                            alt=""
                        />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="background color" min-width="150">
              <template slot-scope="scope">
                <div :style="`background-color:${scope.row.bgColor};height:30px;width:30px`"></div>
              </template>
            </el-table-column>
            <el-table-column label="Short Link" min-width="150">
                <template slot-scope="scope">
                    {{ scope.row.shortLink }}
                </template>
            </el-table-column>
            <el-table-column label="Create Time" prop="createTime" min-width="150"></el-table-column>
            <el-table-column label="Update Time" prop="updateTime" min-width="150"></el-table-column>
            <el-table-column label="Workout Number" prop="workoutCounts" min-width="150"></el-table-column>
            <el-table-column label="options" min-width="240">
                <template slot-scope="scope">
                    <div>
                        <!-- <el-button
                            size="mini"
                            @click="
                                $router.push(
                                    `/library-editor?id=${scope.row.id}`
                                )
                            "
                            >change library</el-button
                        > -->
                        <el-button
                            size="mini"
                            @click="
                                $router.push(
                                    `/library-select-workout?id=${scope.row.id}&name=${scope.row.title}`
                                )
                            "
                            style="background-color:rgb(129,175,201);color:white"
                            >Select workout</el-button
                        >
                        <el-button size="mini" type="danger" @click="Delete(scope.row.id)">Delete</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 30px 0">
            <el-button size="small" @click="sortTable" type="success"
            style="background-color: #417690"
                >Save</el-button
            >
        </div>
        <!-- <el-pagination
            :hide-on-single-page="true"
            background
            layout="total,sizes,prev, pager, next,jumper"
            :total="total"
            :pager-count="5"
            :page-size.sync="pageSize"
            :current-page.sync="nowPage"
            :page-sizes="[40, 50, 60, 100]"
        ></el-pagination> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [
                // { title: "asd", id: 1 },
                // { title: "asda", id: 2 },
                // { title: "asd13", id: 31 },
                // { title: "asd13", id: 32 },
                // { title: "asd13", id: 33 },
                // { title: "asd13", id: 34 },
                // { title: "asd13", id: 35 },
                // { title: "asd13", id: 36 },
                // { title: "asd13", id: 37 },
                // { title: "asd13", id: 38 },
                // { title: "asd13", id: 39 },
                // { title: "asd13", id: 311 },
                // { title: "asd13", id: 312 },
                // { title: "asd13", id: 313 },
                // { title: "asd13", id: 314 },
                // { title: "asd13", id: 315 },
                // { title: "asd13", id: 316 },
                // { title: "asd13", id: 317 },
                // { title: "asd13", id: 318 },
                // { title: "asd13", id: 319 },
                // { title: "asd13", id: 320 },
                // { title: "asd13", id: 321 },
                // { title: "asd13", id: 322 },
                // { title: "asd13", id: 323 },
                // { title: "asd13", id: 324 },
                // { title: "asd13", id: 325 },
                // { title: "asd13123123", id: 326 },
            ],
            pageSize: 40,
            total: 0,
            nowPage: 1,
            tableLoad: false,
            tableSelect: [],
        };
    },
    watch: {
        nowPage: {
            handler() {
                this.getData();
            },
            immediate: true,
        },
    },
    methods: {
        sortTable() {
            this.$request(
                "/manage/library/sort",
                { idList: this.tableData.map((item) => item.id) },
                (res) => {
                    if (res.data.code === 200) {
                        this.$message({
                            message: "modify success",
                            type: "success",
                        });
                    }
                },
                "post"
            );
        },
        handleSelectionChange(val) {
            this.tableSelect = val;
        },
        Delete(id) {
            this.$confirm("Confirm delete？", "", { type: "warning" }).then(() => {
                this.$request(
                    `/manage/library/del/${id}`,
                    {},
                    (res) => {
                        if (res.data.code === 200) {
                            this.$message({
                                message: "delete success",
                                type: "success",
                            });
                            this.getData()
                        }
                    }
                );
            });
        },
        getData() {
            this.tableLoad = true;
            this.$request(
                "/manage/library/list",
                {},
                (res) => {
                    this.tableLoad = false;
                    res.data.data.some(item => {
                        item.createTime = item.createTime.replace('T',' ')
                        item.updateTime && (item.updateTime = item.updateTime.replace('T',' '))
                    })
                    this.tableData = res.data.data;
                },
                "post",
                true
            );
            this.tableLoad = false;
        },
    },
    created() {
        // this.nowPage = 1;
    },
    mounted() {
        this.$sortable.create(
            this.$refs.libraryTable.$el.querySelectorAll("tbody")[0],
            {
                animation: 200,
                // handle: ".move",
                forceFallback: true,
                onEnd: (evt) => {
                    // 循环获取内容lable值返回arrary
                    const item = this.tableData[evt.oldIndex];
                    this.tableData.splice(evt.oldIndex, 1);
                    this.tableData.splice(evt.newIndex, 0, item);
                },
            }
        );
    },
};
</script>

<style scoped>
.all {
    box-sizing: border-box;
    padding: 0 20px;
    text-align: left;
    margin-top: 30px;
}
.title {
    font-size: 20px;
    margin: 40px 0 0;
}
.btns {
    margin: 0 0 2px;
    text-align: right;
}
.el-table {
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
}
.all >>> .tableHeadr th {
    background-color: rgb(121, 174, 200) !important;
    color: white;
}
.all >>> .table-name i:hover {
    color: #447e9b !important;
    cursor: pointer;
}
.all >>> .tableCell {
    color: #447e9b;
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: pre;
}
.all >>> .tableCell:hover {
    cursor: pointer;
    text-decoration: underline;
}
.el-pagination {
    text-align: right;
    margin: 20px 0;
}
.el-table >>> .el-table__row *{
    text-transform: none ;
}
.el-table >>> .el-table__row{
    cursor: move;
}
</style>